class PaginationChange extends HTMLElement {
  constructor () {
    super()
    this.elements = {
      nextTrigger: this.querySelector('[data-pagination-change-el="next-trigger"]'),
      prevTrigger: this.querySelector('[data-pagination-change-el="prev-trigger"]'),
    }

    // Store bound handlers for cleanup
    this._boundHandlers = {
      handleProductsUpdated: (products) => {
        if (products.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden')
        }
      },
      handleNextClick: () => {
        window.theme.tagalys.results.eventBus.publish('results:ui:pagination:changed', {
          direction: 'next',
        })
        this.scrollToTop()
      },
      handlePrevClick: () => {
        window.theme.tagalys.results.eventBus.publish('results:ui:pagination:changed', {
          direction: 'previous',
        })
        this.scrollToTop()
      },
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
    this.attachEventListeners()
  }

  disconnectedCallback () {
    this.unsubscribeFromEvents()
    this.detachEventListeners()
  }

  subscribeToEvents () {
    window.theme.tagalys.results.eventBus.subscribe('results:state:products:updated', this._boundHandlers.handleProductsUpdated)
  }

  unsubscribeFromEvents () {
    window.theme.tagalys.results.eventBus.unsubscribe('results:state:products:updated', this._boundHandlers.handleProductsUpdated)
  }

  attachEventListeners () {
    this.elements.nextTrigger.addEventListener('click', this._boundHandlers.handleNextClick)
    this.elements.prevTrigger.addEventListener('click', this._boundHandlers.handlePrevClick)
  }

  detachEventListeners () {
    this.elements.nextTrigger.removeEventListener('click', this._boundHandlers.handleNextClick)
    this.elements.prevTrigger.removeEventListener('click', this._boundHandlers.handlePrevClick)
  }

  render () {
    const hasNextPage = window.theme.tagalys.results.SDK.helpers.hasNextPage()
    const hasPreviousPage = window.theme.tagalys.results.SDK.helpers.hasPreviousPage()

    if (hasNextPage) {
      this.elements.nextTrigger.classList.remove('hidden')
    } else {
      this.elements.nextTrigger.classList.add('hidden')
    }

    if (hasPreviousPage) {
      this.elements.prevTrigger.classList.remove('hidden')
    } else {
      this.elements.prevTrigger.classList.add('hidden')
    }
  }

  scrollToTop () {
    requestAnimationFrame(() => {
      setTimeout(() => {
        const scrollTop = 0
        const scrollOptions = { top: scrollTop, left: 0 }

        if ('scrollBehavior' in document.documentElement.style) {
          scrollOptions.behavior = 'smooth'
          window.scrollTo(scrollOptions)
        } else {
          window.scrollTo(scrollTop, 0)
        }

        // iOS potential fix: ensure scroll properties are set directly on elements
        document.documentElement.scrollTop = scrollTop
        document.body.scrollTop = scrollTop

        // third potential fix: use scrollIntoView
        const collectionContainer = document.querySelector('[data-section="collection"]') ||
          document.getElementById('ProductGridContainer') ||
          document.querySelector('.collection')

        if (collectionContainer && window.scrollY > 0) {
          collectionContainer.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 50) // account for any lag
    })
  }
}

customElements.define('pagination-change', PaginationChange)
